import { ElNotification } from 'element-plus'
import isString from 'lodash/isString'

import { subjectsForShowNotification } from '@shared/constants/notifications'
import { INotification } from '@shared/models/proto/base/notifications'

export const useNotificationProvider = () => {
  const showNotification = (notification?: INotification) => {
    ElNotification({
      title: notification?.subject ?? '',
      dangerouslyUseHTMLString: true,
      message: notification?.body ?? '',
      position: 'bottom-right',
    })
  }

  const isNotificationShowsBySubject = (subject?: string) => {
    return isString(subject)
      ? subjectsForShowNotification.includes(subject)
      : false
  }

  const checkNotificationAndShow = (notification?: INotification) => {
    if (isNotificationShowsBySubject(notification?.subject)) {
      showNotification(notification)
    }
  }

  return { checkNotificationAndShow }
}
